import React from 'react';
import { Link } from 'react-router-dom';

// Landing de divulgação do SaaS Arena Cyber Café (para donos de lan house / cyber café).
// Estilo: retro-futurism / cyber — verde limão da marca sobre fundo escuro, Orbitron + scanlines + neon glow.
// Diretrizes: ui-ux-pro-max (Retro-Futurism, Orbitron/JetBrains Mono). Logos: 21st.dev (svgl).

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Orbitron:wght@600;700;900&family=Inter:wght@400;500;600;700&display=swap');

.arena-lp { --bg:#0a0a0f; --panel:#12121b; --panel2:#181826; --line:#23233a;
  --lime:#a3e635; --lime2:#84cc16; --text:#f4f4f6; --muted:#8b8b9a;
  font-family:'Inter',system-ui,sans-serif; color:var(--text); background:var(--bg);
  min-height:100vh; overflow-x:hidden; position:relative; }
.arena-lp *{box-sizing:border-box;}
.arena-lp h1,.arena-lp h2,.arena-lp h3,.arena-lp .display{font-family:'Orbitron',sans-serif;letter-spacing:.5px;}
.arena-lp a{color:inherit;text-decoration:none;}
.arena-lp .scan{position:fixed;inset:0;pointer-events:none;z-index:1;opacity:.5;
  background:repeating-linear-gradient(0deg,rgba(255,255,255,.025) 0 1px,transparent 1px 3px);}
.arena-lp .glow-bg{position:absolute;inset:0;z-index:0;pointer-events:none;
  background:radial-gradient(60% 50% at 50% 0%,rgba(163,230,53,.14),transparent 70%),
             radial-gradient(40% 40% at 85% 20%,rgba(132,204,22,.08),transparent 70%);}
.arena-lp .wrap{max-width:1140px;margin:0 auto;padding:0 22px;position:relative;z-index:2;}

/* NAV */
.arena-lp .nav{position:sticky;top:0;z-index:20;backdrop-filter:blur(10px);
  background:rgba(10,10,15,.72);border-bottom:1px solid var(--line);}
.arena-lp .nav .inner{display:flex;align-items:center;gap:24px;height:66px;}
.arena-lp .nav img{height:30px;}
.arena-lp .nav .links{display:flex;gap:26px;margin-left:14px;}
.arena-lp .nav .links a{color:var(--muted);font-size:14px;font-weight:500;transition:color .2s;}
.arena-lp .nav .links a:hover{color:var(--lime);}
.arena-lp .nav .right{margin-left:auto;display:flex;align-items:center;gap:12px;}

.arena-lp .btn{display:inline-flex;align-items:center;gap:8px;border-radius:10px;font-weight:700;
  cursor:pointer;transition:transform .15s,box-shadow .2s,background .2s;border:none;font-size:15px;}
.arena-lp .btn-primary{background:var(--lime);color:#0a0a0f;padding:13px 22px;
  box-shadow:0 0 0 1px rgba(163,230,53,.4),0 0 24px rgba(163,230,53,.35);}
.arena-lp .btn-primary:hover{transform:translateY(-2px);box-shadow:0 0 0 1px var(--lime),0 0 34px rgba(163,230,53,.55);}
.arena-lp .btn-ghost{background:transparent;color:var(--text);border:1px solid var(--line);padding:12px 20px;}
.arena-lp .btn-ghost:hover{border-color:var(--lime);color:var(--lime);}
.arena-lp .btn-sm{padding:9px 16px;font-size:14px;}

/* HERO */
.arena-lp .hero{padding:76px 0 40px;text-align:center;}
.arena-lp .badge{display:inline-flex;align-items:center;gap:8px;border:1px solid var(--line);
  background:var(--panel);border-radius:999px;padding:7px 15px;font-size:13px;color:var(--muted);margin-bottom:26px;}
.arena-lp .badge b{color:var(--lime);}
.arena-lp .hero h1{font-size:clamp(34px,6vw,62px);line-height:1.04;font-weight:900;margin:0 0 20px;}
.arena-lp .hero h1 .hl{color:var(--lime);text-shadow:0 0 24px rgba(163,230,53,.5);}
.arena-lp .hero p.sub{font-size:clamp(16px,2.2vw,20px);color:var(--muted);max-width:640px;margin:0 auto 32px;line-height:1.6;}
.arena-lp .hero .cta{display:flex;gap:14px;justify-content:center;flex-wrap:wrap;}
.arena-lp .hero .note{margin-top:16px;font-size:13px;color:var(--muted);}

/* MOCKUP mapa */
.arena-lp .mock{margin:54px auto 0;max-width:920px;background:linear-gradient(180deg,var(--panel),#0d0d16);
  border:1px solid var(--line);border-radius:18px;padding:18px;box-shadow:0 30px 80px rgba(0,0,0,.6),0 0 0 1px rgba(163,230,53,.06);}
.arena-lp .mock-head{display:flex;align-items:center;gap:8px;padding:2px 6px 14px;border-bottom:1px solid var(--line);margin-bottom:16px;}
.arena-lp .dot{width:11px;height:11px;border-radius:50%;}
.arena-lp .mock-title{margin-left:10px;font-size:13px;color:var(--muted);font-family:'Orbitron';letter-spacing:1px;}
.arena-lp .grid-dev{display:grid;grid-template-columns:repeat(auto-fill,minmax(120px,1fr));gap:12px;}
.arena-lp .dev{background:var(--panel2);border:1px solid var(--line);border-radius:12px;padding:14px 10px;text-align:center;}
.arena-lp .dev.on{border:1.5px solid var(--lime);box-shadow:0 0 0 1px rgba(163,230,53,.25),0 0 18px rgba(163,230,53,.15);}
.arena-lp .dev .ic{font-size:26px;}
.arena-lp .dev.off .ic{filter:grayscale(1);opacity:.4;}
.arena-lp .dev .nm{font-size:12px;font-weight:700;margin-top:6px;}
.arena-lp .dev .st{font-size:12px;margin-top:3px;}
.arena-lp .dev.on .st{color:var(--lime);font-weight:800;font-family:'Orbitron';}
.arena-lp .dev.off .st{color:var(--muted);}

/* LOGOS */
.arena-lp .logos{padding:44px 0 8px;text-align:center;}
.arena-lp .logos p{font-size:13px;color:var(--muted);letter-spacing:1px;text-transform:uppercase;margin-bottom:20px;}
.arena-lp .logos .row{display:flex;gap:38px;justify-content:center;align-items:center;flex-wrap:wrap;opacity:.85;}
.arena-lp .logos img{height:26px;filter:grayscale(1) brightness(1.6);opacity:.7;transition:.2s;}
.arena-lp .logos img:hover{filter:none;opacity:1;}

/* SECTIONS */
.arena-lp section{padding:64px 0;position:relative;z-index:2;}
.arena-lp .eyebrow{color:var(--lime);font-family:'Orbitron';font-size:13px;letter-spacing:2px;text-transform:uppercase;text-align:center;margin-bottom:10px;}
.arena-lp .h2{font-size:clamp(26px,4vw,40px);font-weight:800;text-align:center;margin:0 0 12px;}
.arena-lp .lead{color:var(--muted);text-align:center;max-width:620px;margin:0 auto 44px;font-size:17px;line-height:1.6;}

.arena-lp .features{display:grid;grid-template-columns:repeat(3,1fr);gap:16px;}
.arena-lp .feat{background:var(--panel);border:1px solid var(--line);border-radius:16px;padding:26px 22px;transition:.2s;}
.arena-lp .feat:hover{border-color:rgba(163,230,53,.5);transform:translateY(-3px);}
.arena-lp .feat .ico{width:44px;height:44px;border-radius:11px;display:flex;align-items:center;justify-content:center;
  background:rgba(163,230,53,.1);border:1px solid rgba(163,230,53,.3);color:var(--lime);margin-bottom:16px;}
.arena-lp .feat h3{font-size:18px;margin:0 0 8px;}
.arena-lp .feat p{color:var(--muted);font-size:14.5px;line-height:1.6;margin:0;}

/* STEPS */
.arena-lp .steps{display:grid;grid-template-columns:repeat(3,1fr);gap:18px;}
.arena-lp .step{position:relative;padding:26px 22px;background:var(--panel);border:1px solid var(--line);border-radius:16px;}
.arena-lp .step .n{font-family:'Orbitron';font-size:40px;font-weight:900;color:rgba(163,230,53,.28);line-height:1;}
.arena-lp .step h3{font-size:18px;margin:10px 0 8px;}
.arena-lp .step p{color:var(--muted);font-size:14.5px;line-height:1.6;margin:0;}

/* PRICING */
.arena-lp .plans{display:grid;grid-template-columns:repeat(3,1fr);gap:16px;align-items:stretch;}
.arena-lp .plan{background:var(--panel);border:1px solid var(--line);border-radius:18px;padding:28px 24px;display:flex;flex-direction:column;}
.arena-lp .plan.pop{border:1.5px solid var(--lime);box-shadow:0 0 40px rgba(163,230,53,.12);position:relative;}
.arena-lp .plan .tag{position:absolute;top:-12px;left:50%;transform:translateX(-50%);background:var(--lime);color:#0a0a0f;
  font-size:11px;font-weight:800;padding:4px 12px;border-radius:999px;font-family:'Orbitron';letter-spacing:1px;}
.arena-lp .plan .pn{font-family:'Orbitron';font-size:18px;font-weight:700;}
.arena-lp .plan .pd{color:var(--muted);font-size:13px;margin:4px 0 16px;}
.arena-lp .plan .price{font-family:'Orbitron';font-size:34px;font-weight:900;}
.arena-lp .plan .price small{font-size:14px;color:var(--muted);font-family:'Inter';font-weight:500;}
.arena-lp .plan ul{list-style:none;padding:0;margin:18px 0 22px;display:flex;flex-direction:column;gap:11px;}
.arena-lp .plan li{font-size:14px;color:#d7d7de;display:flex;gap:9px;align-items:flex-start;}
.arena-lp .plan li svg{color:var(--lime);flex-shrink:0;margin-top:2px;}
.arena-lp .plan .btn{margin-top:auto;justify-content:center;width:100%;}

/* CTA */
.arena-lp .final{text-align:center;background:linear-gradient(180deg,transparent,rgba(163,230,53,.05));
  border:1px solid var(--line);border-radius:22px;padding:56px 28px;margin:20px 0;}
.arena-lp .final h2{font-size:clamp(26px,4vw,42px);margin:0 0 14px;}
.arena-lp .final p{color:var(--muted);font-size:17px;margin:0 0 28px;}

/* FOOTER */
.arena-lp footer{border-top:1px solid var(--line);padding:38px 0;position:relative;z-index:2;}
.arena-lp footer .inner{display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;gap:16px;}
.arena-lp footer img{height:26px;}
.arena-lp footer .mut{color:var(--muted);font-size:13px;}

@media(max-width:860px){
  .arena-lp .nav .links{display:none;}
  .arena-lp .features,.arena-lp .steps,.arena-lp .plans{grid-template-columns:1fr;}
}
`;

function Ico({ d }) {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{d}</svg>
  );
}
const Check = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"
    strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12" /></svg>
);

const FEATURES = [
  { t: 'Mapa em tempo real', d: 'Veja cada PC, PS5, cockpit e VR no mapa por zonas — livre (apagado) ou em uso (verde) com nick e contador regressivo.',
    ic: <><rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" /><rect x="14" y="14" width="7" height="7" /><rect x="3" y="14" width="7" height="7" /></> },
  { t: 'Tempo pré-pago self-service', d: 'O cliente cria conta no próprio PC, faz login e joga enquanto tem tempo. Acabou, ele mesmo compra mais.',
    ic: <><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></> },
  { t: 'Recarga por PIX no app', d: 'Integração Mercado Pago: o cliente recarrega o saldo por PIX sem sair do app. Crédito automático.',
    ic: <><rect x="2" y="5" width="20" height="14" rx="2" /><line x1="2" y1="10" x2="22" y2="10" /></> },
  { t: 'Lanchonete / POS', d: 'Produtos com foto, custo, estoque e margem. Venda no caixa ou o próprio cliente pede pelo PC, descontando do saldo.',
    ic: <><circle cx="9" cy="21" r="1" /><circle cx="20" cy="21" r="1" /><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" /></> },
  { t: 'Multi-dispositivo', d: 'PC, PlayStation 5, cockpit/simulador e VR (Meta Quest) — cada tipo com seu ícone e controle no mapa.',
    ic: <><rect x="2" y="3" width="20" height="14" rx="2" /><line x1="8" y1="21" x2="16" y2="21" /><line x1="12" y1="17" x2="12" y2="21" /></> },
  { t: 'Cliente Windows kiosk', d: 'Instala num clique, ativa por chave, valida os jogos instalados em cada PC e se atualiza sozinho pela nuvem.',
    ic: <><path d="M9 3v18M3 9h18" /><rect x="3" y="3" width="18" height="18" rx="2" /></> },
  { t: 'Caixa e pagamentos', d: 'Venda de pacotes e produtos, PIX, dinheiro e cartão registrados no caixa. Assinatura recorrente via Asaas.',
    ic: <><line x1="12" y1="1" x2="12" y2="23" /><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" /></> },
  { t: 'Bloqueio e segurança', d: 'Níveis de bloqueio configuráveis (nenhum, parcial, kiosk total) e alerta sonoro quando o tempo de um aparelho zera.',
    ic: <><rect x="3" y="11" width="18" height="11" rx="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></> },
  { t: 'Multi-lan house (SaaS)', d: 'Gerencie uma ou várias unidades. Cada lan house recebe dos clientes na própria conta; você acompanha tudo.',
    ic: <><path d="M3 21h18M5 21V7l8-4v18M19 21V11l-6-4" /></> },
];

const BRANDS = ['mercadopago', 'steam', 'discord', 'windows', 'playstation', 'epicgames'];

export default function LandingPage() {
  return (
    <div className="arena-lp">
      <style>{CSS}</style>
      <div className="scan" />
      <div className="glow-bg" />

      {/* NAV */}
      <nav className="nav"><div className="wrap inner">
        <img src="/logo.png" alt="Arena Cyber Café" />
        <div className="links">
          <a href="#recursos">Recursos</a>
          <a href="#como">Como funciona</a>
          <a href="#planos">Planos</a>
        </div>
        <div className="right">
          <Link to="/login" className="btn btn-ghost btn-sm">Entrar</Link>
          <a href="#planos" className="btn btn-primary btn-sm">Testar grátis</a>
        </div>
      </div></nav>

      {/* HERO */}
      <header className="hero"><div className="wrap">
        <span className="badge">⚡ <b>Sistema completo</b> para lan houses e cyber cafés</span>
        <h1>Gerencie sua lan house<br /><span className="hl">como um verdadeiro pro.</span></h1>
        <p className="sub">Tempo pré-pago, recarga por PIX, lanchonete, mapa em tempo real e cliente Windows kiosk — tudo num sistema só. Do PC ao PlayStation e VR.</p>
        <div className="cta">
          <a href="#planos" className="btn btn-primary">Começar agora</a>
          <a href="#como" className="btn btn-ghost">Ver como funciona</a>
        </div>
        <div className="note">7 dias grátis · sem cartão · seus clientes pagam por PIX na hora</div>

        {/* MOCKUP do mapa */}
        <div className="mock">
          <div className="mock-head">
            <span className="dot" style={{ background: '#ef4444' }} /><span className="dot" style={{ background: '#f59e0b' }} /><span className="dot" style={{ background: '#22c55e' }} />
            <span className="mock-title">MAPA DA ARENA — TEMPO REAL</span>
          </div>
          <div className="grid-dev">
            <div className="dev on"><div className="ic">🖥️</div><div className="nm">PC 01</div><div className="st">⏳ 42:10</div></div>
            <div className="dev on"><div className="ic">🖥️</div><div className="nm">PC 02</div><div className="st">⏳ 08:55</div></div>
            <div className="dev off"><div className="ic">🖥️</div><div className="nm">PC 03</div><div className="st">Livre</div></div>
            <div className="dev on"><div className="ic">🎮</div><div className="nm">PS5 01</div><div className="st">⏳ 1:12:00</div></div>
            <div className="dev off"><div className="ic">🥽</div><div className="nm">VR 01</div><div className="st">Livre</div></div>
            <div className="dev off"><div className="ic">🏎️</div><div className="nm">Cockpit</div><div className="st">Livre</div></div>
          </div>
        </div>
      </div></header>

      {/* LOGOS */}
      <div className="logos"><div className="wrap">
        <p>Integra e roda com as plataformas que você já usa</p>
        <div className="row">
          {BRANDS.map(b => <img key={b} src={`/brands/${b}.svg`} alt={b} />)}
        </div>
      </div></div>

      {/* RECURSOS */}
      <section id="recursos"><div className="wrap">
        <div className="eyebrow">Recursos</div>
        <h2 className="h2">Tudo que sua operação precisa</h2>
        <p className="lead">Um sistema pensado para lan houses e cyber cafés brasileiros — do atendimento ao caixa, do PC ao console.</p>
        <div className="features">
          {FEATURES.map(f => (
            <div className="feat" key={f.t}>
              <div className="ico"><Ico d={f.ic} /></div>
              <h3>{f.t}</h3>
              <p>{f.d}</p>
            </div>
          ))}
        </div>
      </div></section>

      {/* COMO FUNCIONA */}
      <section id="como"><div className="wrap">
        <div className="eyebrow">Como funciona</div>
        <h2 className="h2">No ar em minutos</h2>
        <p className="lead">Sem instalação complicada. Baixou, ativou por chave, configurou — pronto.</p>
        <div className="steps">
          <div className="step"><div className="n">01</div><h3>Instale nos PCs</h3><p>Baixe o cliente Windows, cole a chave de ativação e dê um nome. O PC aparece no mapa na hora.</p></div>
          <div className="step"><div className="n">02</div><h3>Configure</h3><p>Cadastre jogos, pacotes de hora, produtos da lanchonete e conecte seu Mercado Pago para receber por PIX.</p></div>
          <div className="step"><div className="n">03</div><h3>Cliente joga</h3><p>O gamer cria conta no PC, recarrega o saldo, compra tempo e joga. Você acompanha tudo pelo mapa.</p></div>
        </div>
      </div></section>

      {/* PLANOS */}
      <section id="planos"><div className="wrap">
        <div className="eyebrow">Planos</div>
        <h2 className="h2">Preço que cabe na sua operação</h2>
        <p className="lead">Comece grátis por 7 dias. Sem fidelidade — cancele quando quiser.</p>
        <div className="plans">
          <div className="plan">
            <div className="pn">Essencial</div><div className="pd">Para começar</div>
            <div className="price">R$ 79<small>/mês</small></div>
            <ul>
              <li><Check /> Até 10 dispositivos</li>
              <li><Check /> Mapa, tempo e caixa</li>
              <li><Check /> Lanchonete / POS</li>
              <li><Check /> Recarga por PIX</li>
            </ul>
            <a href="#" className="btn btn-ghost">Testar grátis</a>
          </div>
          <div className="plan pop">
            <div className="tag">MAIS POPULAR</div>
            <div className="pn">Pro</div><div className="pd">Para crescer</div>
            <div className="price">R$ 149<small>/mês</small></div>
            <ul>
              <li><Check /> Até 40 dispositivos</li>
              <li><Check /> Tudo do Essencial</li>
              <li><Check /> Multi-dispositivo (PS5, VR, cockpit)</li>
              <li><Check /> Atualização remota dos PCs</li>
              <li><Check /> Suporte prioritário</li>
            </ul>
            <a href="#" className="btn btn-primary">Testar grátis</a>
          </div>
          <div className="plan">
            <div className="pn">Rede</div><div className="pd">Várias unidades</div>
            <div className="price">Sob<small> consulta</small></div>
            <ul>
              <li><Check /> Dispositivos ilimitados</li>
              <li><Check /> Multi-lan house</li>
              <li><Check /> Relatórios consolidados</li>
              <li><Check /> Onboarding dedicado</li>
            </ul>
            <a href="#" className="btn btn-ghost">Falar com a gente</a>
          </div>
        </div>
      </div></section>

      {/* CTA FINAL */}
      <div className="wrap"><div className="final">
        <h2>Pronto para modernizar sua lan house?</h2>
        <p>Junte-se aos cyber cafés que já rodam no Arena. 7 dias grátis, sem cartão.</p>
        <a href="#planos" className="btn btn-primary">Começar agora</a>
      </div></div>

      {/* FOOTER */}
      <footer><div className="wrap inner">
        <img src="/logo.png" alt="Arena Cyber Café" />
        <span className="mut">© {new Date().getFullYear()} Arena Cyber Café — um produto da agência interativa.</span>
        <Link to="/login" className="mut" style={{ color: 'var(--lime)' }}>Entrar no painel →</Link>
      </div></footer>
    </div>
  );
}
